<template>
  <!-- 手动催评-批量发送短信组件 -->
  <div class="sendSms">
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      :with-header="false"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <div class="wrapper">
        <!-- 头部设置 -->
        <header class="head">
          <div class="left">
            <span class="tit">发送短信</span>
          </div>
          <i class="el-icon-close close" @click="handleClose"></i>
        </header>
        <!-- 温馨提示 -->
        <div class="topTis">
          <!-- <i
            class="el-icon-warning"
            style="color: #FE333B; marginright: 8px"
          ></i> -->
           <img

          src="@/assets/images/new_icon_reminder.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 5px 4px 0 3px;
          "
        />
          <div class="desc" >
            <p>温馨提示</p>
            <p>
              此功能为京东官方功能，请先报备店铺签名，再筛选人群数据哦；且短信发送后第二天才可查看营销效果分析~
              <span @click="hancdClick" style="margin-left:10px" class="descButtom">去设置</span>
            </p>
            <p>
              1.提交号码数量超过100W（含100W）的短信发送需要审核，审核时间是每日18点，短信发送时间范围为：早9:00-晚
              20:00（日常）
            </p>
            <p>
              2.京东官方短信频控规则：同一商家2天内给同一手机号发送营销短信条数不超过1条；每个手机号每
              1 天只能收到 3 条京东商家短信，每 2 天只能收到 5 条京东商家短信
            </p>
          </div>
        </div>
        <section class="main">
          <!-- 表单内容 -->
          <el-form ref="formSearch" :model="form" label-width="80px">
            <el-form-item label="发送对象:"
              >已选择
             <i v-show="preLoading" :style="{ color: globalBG }" class="el-icon-loading"></i>
              <span style="color: #fe4d45" v-show="!preLoading">{{ sendObjectCount }}</span>
              位会员</el-form-item
            >

            <el-form-item label="活动主题:">
              <el-input max v-model="form.title"> </el-input>
            </el-form-item>

            <el-form-item label="编辑短信:">
              <div class="textarea">
                <el-input
                class="textareaChange"
                  type="textarea"
                  :rows="5"
                  placeholder="请输入内容"
                  v-model="form.content"
                >
                </el-input>
                <div class="footInfo">
                  <div>
                    <button class="select" @click.prevent="templateShow = true">
                      选择模板
                    </button>
                    <button class="keep" @click.prevent="handleShowModule">
                      保存模板
                    </button>
                    <span
                      >已输入
                      <span style="color: #fe4d45">{{
                        form.content.length + (suffixList[0] ? suffixList[0].length : 0) + 5
                      }}</span>
                      个字（含签名及退订文字），预计
                      {{
                        Math.ceil(
                          sendInfoLength > 70
                            ? sendInfoLength / 67
                            : sendInfoLength / 70
                        )
                      }}
                      条短信
                    </span>
                  </div>
                  <div class="ask-content">
                    <span
                      style="
                        font-weight: normal;
                        margin-left: 8px;
                        color: #7f85e9;
                      "
                      >计费规则</span
                    >
                    <el-tooltip 
                    class="item"
                    effect="light"
                    placement="top-start">
                      <div v-html="content1" slot="content"></div>
                       <span class="question_icon" style="margin-left: 4px"
                      >?</span
                    >
                    </el-tooltip>
                  </div>
                </div>
              </div>
             <div class="footTips" style="height: 52px; position: relative">
                <img
                  src="@/assets/images/new_icon_waring_yellow.png"
                  style="
                    display: inline-block;
                    float: left;
                    position: absolute;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 0px 4px 0 0;
                    top: 9px;
                  "
                />
                <span style="margin-left: 15px; line-height: 21px"
                  >（1）短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链;
                  <br>
                  （2）生成短链后建议复制到手机浏览器打开确保短链接能正常打开。</span
                >
            </div>
            </el-form-item>

            <el-form-item label="短信签名:">
              <div class="btnList">
                <div
                  class="btnBox"
                  v-for="(item, index) in suffixList"
                  :key="'label' + index"
                  @click.prevent="switchSuffix(item)"
                >
                  <button class="btn">{{ item }}</button>
                  <span class="check" v-if="form.smsSuffix === item">
                    <i class="el-icon-check"></i>
                  </span>
                </div>
                <span
                  style=" font-size: 14px; cursor: pointer"
                  class="btnListButtom"
                  @click="replaceSignature"
                  >更换</span
                >
              </div>
            </el-form-item>

            <el-form-item label="辅助工具:">
              <div class="tool">
                <p @click.prevent="insertShortUrlShow = true">
                  <i class="iconfont iconbtn_duanwangzhi"></i>插入短网址
                </p>
              </div>
            </el-form-item>

            <el-form-item label="会员过滤:">
              <!-- <el-checkbox-group > -->
              <el-checkbox :label="1" v-model="form.blackFlag">
                黑名单
                <span
                  @click.stop="toBlack"
                  style="color: #7f85e9; margin-left: 8px"
                  >设置黑名单</span
                >
              </el-checkbox>
              <!-- </el-checkbox-group> -->
            </el-form-item>

            <el-form-item label="短信过滤">
              <div style="display: flex">
                <el-radio-group v-model="form.fitlerDay">
                  <el-radio :label="0">不过滤</el-radio>
                  <el-radio :label="3">3天</el-radio>
                  <el-radio :label="5">5天</el-radio>
                  <el-radio :label="7">7天</el-radio>
                  <el-radio :label="15">15天</el-radio>
                  <el-radio :label="99">天内发送过的客户</el-radio>
                </el-radio-group>
                <el-input
                  v-model="sendOutIpt"
                  placeholder="填写发送数"
                  style="width: 120px; marginleft: 8px"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item label="短信测试:">
              <div class="test">
                <el-input
                  v-model="smsTest"
                  placeholder="可输入5个，多个号码用“，”隔开"
                  class="ipt"
                  @change="sendMobileChange"
                ></el-input>
                <button class="sendTest" @click.prevent="sendSmsTest(true)">
                  发送短信测试
                </button>
                <button class="record" @click.prevent="smsDialogs = true">
                  短信记录
                </button>
                <!-- <el-checkbox v-model="form.isJoin">加入正式发送</el-checkbox> -->
              </div>
              <!-- <div class="info">
                <p>
                  （1）测试手机号如果输入报备手机导不受每日接收条数限制，否则受接收限制
                </p>
                <p>
                  （2）发送测试短信不受发送时间限制，点击发送后，测试短信立即发送
                </p>
                <p>
                  （3）测试短信不能携带特殊字符“#”号，发送测试短信时系统会自动剔除标量标签再发送！
                </p>
              </div> -->
            </el-form-item>

            <el-form-item label="发送时间:">
              <div>
                <el-date-picker
                  class="pickerTime"
                  v-model="sendStart"
                  type="date"
                  format="yyyy-MM-dd"
                  @change="dateChange"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="expireTimeOption1"
                  style="width: 136px"
                ></el-date-picker>

                <el-time-picker
                  class="pickerTime"
                  v-model="sendEnd"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  :picker-options="expireTimeOption2"
                  placeholder="选择时间"
                  style="margin-left: 8px; width: 136px"
                ></el-time-picker>
              </div>
            </el-form-item>
          </el-form>
          <div class="activeTip">{{globalActivityTip}}</div>
          <!-- <div style="width:1300px;line-height:22px;color:red;margin-top:-16px;margin-bottom:4px">
                 <div>注意：（1）618大促期间短信发送时间：5月30日-6月15日为8:00-22:00，6月16日-6月17日为8:00-次日01:00，6月18日为00:00-23:59:59，6月19日起恢复正常（即9:00-20:00）。</div>
          <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）5月31日-6月18日京东官方短信频控规则:同一商家2天内给同一手机号发送营销短信条数不超过 1 条;每个手机号每 1 天只能收到 9条京东商家短信,每 2 天只能收到 16条京东商家短信。</div>
          </div> -->
          <!-- 短信预览效果 -->
          <div class="xiao-hug xiao_hug2">
            <div style="margin: 0 auto; width: 256px">
              <div
                class="mobile-box"
                :style="{ background: 'url(' + mobileScreen + ') no-repeat' }"
              >
                <div class="message-content">
                  【{{ form.smsSuffix }}】{{ form.content }}{{ TTip }}
                </div>
              </div>
              <div class="mobile-tips">短信预览效果</div>
            </div>
          </div>
        </section>

        <!-- 底部发送 -->
        <footer class="foot">
          <button class="btn" @click="sendSmsTest(false)">发送</button>
          <p class="txt">
            共筛选出 <span style="color:#fe4d45">{{ sendObjectCount }}</span> 会员，
            预计消耗短信 <span style="color:#fe4d45">{{ sendObjectCount * Math.ceil(
                  sendInfoLength > 70
                    ? sendInfoLength / 67
                    : sendInfoLength / 70
                ) }}</span> 条
            (当前短信余额
            <span class="num">
              {{
                this.$store.getters.loginUserInfo.paySmsTotal -
                  this.$store.getters.loginUserInfo.useSmsTotal || "--"
              }}
            </span>
            条)
          </p>
        </footer>
      </div>
    </el-drawer>

    <!-- 选择模板 -->
    <sms-template
      v-if="templateShow"
      :isShow="templateShow"
      @close="templateChange"
    ></sms-template>

    <!-- 保存模板 -->
    <my-popup
      title="保存模板"
      width="370"
      :flag="keepTmpShow"
      @close="keepTmpChange"
    >
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select
            v-model="keepTmpValue"
            placeholder="请选择"
            style="width: 240px"
          >
            <el-option
              v-for="(item, index) in dirList"
              :key="index"
              :label="item.title"
              :value="item.tid"
            ></el-option>
            <!-- <el-option label="云短信旗舰店专用" :value="1"></el-option>
            <el-option label="太阳短信旗舰店专用" :value="2"></el-option>
            <el-option label="月亮短信旗舰店专用" :value="3"></el-option>-->
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

    <!-- 插入短链接 -->
      <insert-short-dialog
      v-if="insertShortUrlShow"
      :typeSms="2"
      :zIndex="99999"
      @close="insertUrlChange"
    ></insert-short-dialog>

    <!-- <insert-coupon-url
      v-if="insertShortUrlShow"
      @close="insertUrlChange"
    ></insert-coupon-url> -->

    <!-- 插入优惠券链接 -->
    <insert-coupon-link
      v-if="insertCouponShow"
      :isShow="insertCouponShow"
      @close="insertCouponChange"
    ></insert-coupon-link>

    <!-- 发送确认 -->
    <my-popup
      :flag="sendSmsTestState"
      title="发送确认"
      @close="sendSmsTestClose"
      width="500"
    >
      <div class="sendSmsTestWrap">
        <p class="detailsInfo">
          <span v-if="isTestSend"
            >提交号码为<span style="color:#FE4D45">{{ smsTest && smsTest.split(",").length }} </span></span
          >
          <span v-else>发送人数为<span style="color:#FE4D45">{{ sendObjectCount }} </span>，</span>
          当前短信字数为 <span style="color:#FE4D45">{{ sendInfoLength }} </span>字，每条短信以
          
          <span style="color:#FE4D45">{{
            Math.ceil(
              sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
            )
          }} </span>
          条计费，
          <span v-if="isTestSend"
            >提交
            <span style="color:#FE4D45">
            {{
              smsTest &&
                smsTest.split(",").length *
                  Math.ceil(
                    sendInfoLength > 70
                      ? sendInfoLength / 67
                      : sendInfoLength / 70
                  )
            }}
            </span>
            条短信，以实际发送条数为准！</span
          >
          <span v-else
            >提交
            <span style="color:#FE4D45">
            {{
              sendObjectCount *
                Math.ceil(
                  sendInfoLength > 70
                    ? sendInfoLength / 67
                    : sendInfoLength / 70
                )
            }}
            </span>
            条短信，以实际发送条数为准！</span
          >
        </p>
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
        <el-button @click="sendSmsTestState = false">取消</el-button>
      </div>
    </my-popup>

    <!-- 短信记录 -->
    <smsTemplatesX
      v-if="smsDialogs"
      :smsDialog="smsDialogs"
      @transferName="transferName"
      @close="smsDialogClose"
    />
    <!-- 发送成功提示 -->
    <el-dialog
      :visible.sync="successDialog"
      title="提示"
      width="400px"
      append-to-body
      custom-class="send-con-dialog"
    >
      <div class="success-tip">
        <img src="@/assets/images/tip_success.png" />
        <span>亲，短信已经成功提交了哦！</span>
      </div>
      <div class="btn-group">
        <el-button @click="handleViewRecord">查看记录</el-button>
        <el-button type="primary" @click="handleConSending">继续发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import smsTemplate from "../sms_template";
import { mapState } from "vuex";
import myPopup from "../../../components/myPopup";
import smsTemplatesX from "../../../components/sms-templates-x";
import insertCouponLink from "../insert_coupon_link";
import insertCouponUrl from "./insert-short-url";
import { smsSend } from "@/api/smsController";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { preCommit, platformSend, getSendTime } from "@/api/smsSend";
import { getTemplateDir, createTemplate } from "@/api/smsTemplates";
import insertShortDialog from "@/components/insert-short-dialog";

export default {
  props: {
    drawer: {
      // 显示隐藏状态控制
      type: Boolean,
      default: false,
    },
    checkData: {
      // 列表选中的数据
      type: Array,
      default: () => {
        return [];
      },
      require: true,
    },
    sendType: {
      // 发送类型 1 按条件查询 2 勾选 3 按会员分组 0 其他
      type: Number,
    },
    taskName: {
      // 任务名称
      type: String,
    },
    dataFrom: {
      // 数据来源类型 0 测试短信 1 会员发送 2 订单发送 4 输入号码发送 5 指定号码发送 6 变量短信发送 7 手动催评 8 手动回评 9 手动审核退款 10 营销汇总分析发送
      type: Number,
    },
    count: {
      // 发送人数
      type: Number,
    },
    searchForm: {
      // 存储按查询结果发送短信需要的查询参数
      type: Object,
    },
  },
  components: {
    smsTemplate,
    myPopup,
    insertCouponLink,
    insertCouponUrl,
    smsTemplatesX,
    insertShortDialog
  },
  watch: {
    drawer(newVal) {
      if (newVal) {
        this.limitSendTime();
        this.getOfficialSuffix(); // 获取店铺签名
        this.form.title = this.taskName + this.getNowDate(); // 活动主题
        // 预提交接口
        this.sendObjectCount = 0;
        this.sendObjectId = '';
        this.handlePreSend();
      }
    },
  },
  computed: {
    ...mapState({
      globalActivityTip: "globalActivityTip",
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    content1() {
      return (
        "<div>每个汉字，字母或标点空格都算作一个字。</div>" +
        "<div>1.70个字计1条短信，超过70字按照67字每条计费。</div>" +
        "<div>2.带标签短信以实际发送为准，有可能超过默认字数。</div>" +
        '<div>3."签名"与"回T退订"包含在字数中。</div>'
      );
    },
    sendInfoLength() {
      try {
        if (this.form.content) {
          return (
            this.form.content.length +
            this.form.smsSuffix.length +
            2 +
            this.TTip.length
          );
        } else {
          return 0;
        }
      } catch (e) {
        return 0;
      }
    },
  },
  mounted() {
    // this.getOfficialSuffix();
  },
  data() {
    return {
      sendObjectCount: 0,
      preLoading: false,
      sendObjectId: '',

      successDialog: false,
      // 表单数据
      form: {
        title: "",
        content: "",
        blackFlag: false,
        fitlerDay: 0,
        smsSuffix: "",
        sendTime: "",
        url: "",
      },
      //保存模板数据
      dirList: [],
      // 短链接
      insertCoupon: "",
      // 短链接原地址
      url: "",
      // 短信测试值
      smsTest: null,
      // 短信签名列表
      suffixList: [],
      sendOutIpt: null,
      // 短信模板状态控制
      templateShow: false,
      // 保存模板状态控制 ---- 内容
      keepTmpShow: false,
      keepTmpValue: "",
      // 插入短链接状态控制 ----- 内容
      insertShortUrlShow: false,
      insertUrlValue: null,
      //短信记录弹窗
      smsDialogs: false,
      // 插入优惠券链接控制
      insertCouponShow: false,
      // 京东跳转App链接控制 ---- 内容
      jdJumpLinkShow: false,
      jumpLinkSelectValue: 0,
      jumpLinkIptValue: null,
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      // 发送时间
      sendStart: "",
      sendEnd: "",
      expireTimeOption1: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 8.64e7 || date.getTime() > Date.now() + 8.64e7 * 90;
        },
      },
      expireTimeOption2: {
        selectableRange: "9:00:00 - 19:55:59",
      },
      limitTime: {},
      TTip: "回T退",
      // 发送短信确认弹窗状态
      sendSmsTestState: false,
      isTestSend: false,
    };
  },
  methods: {
     dateChange(val) {
      var nowTime10 = this.getNowDate2();
      var time1 = nowTime10.substring(0, 10);
      var time2 = nowTime10.substring(11, 19);
      var startTime = this.limitTime.startTime;
      var endTime = this.limitTime.endTime;
      // var time2 = "20:58:59";
      var arr = time2.split(":");
      var endArr = endTime.split(":")


      // 最晚可以选到时间
      if (arr[0] > endArr[0]) {
        time2 = endTime;
      } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
        time2 = endTime;
      } else if (arr[0] == endArr[0] && arr[1] == endArr[1] && arr[2] >= endArr[2]) {
        time2 = endTime;
      }

      // 选择时间为空
      this.sendEnd = "";

      if (val == time1) {
        this.expireTimeOption2.selectableRange = time2 + " - " + endTime;
      } else {
        this.expireTimeOption2.selectableRange = startTime + ' - ' + endTime;
      }
    },

    //判读时间函数
    expireTimeOption3() {
      let yy = new Date().getFullYear();
       let mm = new Date().getMonth() + 1 < 10 ? "0" + new Date().getMonth() + 1: new Date().getMonth() + 1;
       let dd = new Date().getDate() < 10  ? "0" + new Date().getDate() : new Date().getDate();
          let dd1=`${yy}-${mm}-${dd}`;
        let hh = new Date().getHours();
        let mf =new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
       let mf1="00";
       let mf2="55";
       let mf4=new Date().getMinutes() + 1;
       let mf3=mf4<10 ? '0'+ mf4  : mf4 ;
       let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
       let ss3 = new Date().getSeconds() + 1<10 ? '0'+new Date().getSeconds() + 1 : new Date().getSeconds() + 1;
      //  console.log(mf3);
      //  console.log(ss3);
      //  console.log(mf4);
        let ss1="00";
       let ss2="59";

       if (dd1==this.sendStart) {
           if (mf==59&&hh<19&&ss==59) {
             console.log(111);
              // console.log(this.expireTimeOption2.selectableRange);
              this.expireTimeOption2={
              selectableRange: `${hh+1}:${mf1}:${ss1} - ${19}:${mf2}:${ss2}`,
            };
            }else if (mf<59&&hh<19&&ss==59) {
              console.log(222);
               this.expireTimeOption2={
              selectableRange: `${hh}:${mf3}:${ss1} - ${19}:${mf2}:${ss2}`,
            };
            }else if(mf<59&&hh<19&&ss<59){
              console.log(333);
              this.expireTimeOption2={
              selectableRange: `${hh}:${mf3}:${ss3} - ${19}:${mf2}:${ss2}`,
            };
            console.log(this.expireTimeOption2);
            }else if (hh==19&&mf<=55&&ss<59) {
              this.expireTimeOption2={
              selectableRange: `${hh}:${mf3}:${ss3} - ${19}:${mf2}:${ss2}`,
            };
            }else if (hh==19&&mf>55) {
              this.sendStart="";
              this.$message.warning("今日不可发送短信，请重新选择");
            }else if (hh>19) {
               this.sendStart="";
              this.$message.warning("今日不可发送短信，请重新选择");
            }
          }else{
            this.expireTimeOption2= {
        selectableRange: "9:00:00 - 19:55:59",
           };
          }
    },
    getNowDate2() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }

      date.setMinutes(date.getMinutes() + 10);
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }

      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes +
        seperator2 +
        Seconds;

      return currentdate;
    },

     // 官方发送，发送时间的限制
    limitSendTime() {
      getSendTime().then(res => {
        this.limitTime = res.data;
        var selectableRange = res.data.startTime + ' - ' + res.data.endTime
        this.expireTimeOption2.selectableRange = selectableRange
      })
    },
    
    // 去设置
    hancdClick() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
        // query: { tabIndex: 2, groupName: 1 + ind },
      });
      window.open(routeUrl.href, "_blank");
    },
    // insertUrlValues(insertUrlValue) {
    //   // this.form.url = insertUrlValue;
    // },
    // 抽屉隐藏
    handleClose() {
      this.$emit("close", false);
      // return
      this.templateShow = false;
      // 清空数据
      this.form = {
        title: "",
        content: "",
        blackFlag: false,
        fitlerDay: 0,
        smsSuffix: "",
        sendTime: "",
        url: "",
      };
      this.smsTest = null;
      this.sendStart = null;
      this.sendEnd = null;
    },
    // // 短信模板隐藏
    // templateChange(state, data) {
    //   this.templateShow = false;
    //   if (data)
    //     this.form.content = this.form.content
    //       ? this.form.content + data.content
    //       : data.content;
    // },
    // 继续发送
    handleConSending() {
      this.successDialog = false;
      this.handleClose();
    },
    // 查看记录
    handleViewRecord() {
      this.handleClose();
      this.successDialog = false;
      var path = '/marketing/marketing/member_send'
      if (this.dataFrom == '4') {
        path = '/marketing/marketing/designated_send'
      }
      if (this.dataFrom == '7' || this.dataFrom == '8' || this.dataFrom == '9') {
        path = '/backstage/backstage/sms_reply_record'
      }
      let routeUrl = this.$router.resolve({
        path: path,
        query: { to: "focusShop" },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 保存模板隐藏
    templateChange(val, item) {
      console.log("选择模板的返回==", val, item);
      // this.inputContent = item.content;
      if (val == true) {
        this.selectTemplate = item;
        // this.form.content = this.form.content ? this.form.content : "";
        this.form.content = item.content;
      }
      this.templateShow = false;
    },

    // 保存模板 显示
    handleShowModule() {
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.dirList = res.data;
          this.keepTmpShow = true;
        }
      });
      console.log(this.dirList);
    },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.form.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("保存模板成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    //更换签名
    replaceSignature() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 插入短链接隐藏
    // insertUrlChange(state, data, url) {
    insertUrlChange(val, obj) {
      this.insertShortUrlShow = false;
      if (!val) {
        return;
      }
      var data = obj.shortLink,
      url = obj.originUrl;
      console.log(data, url);
    
      if (this.insertCoupon == "") {
        this.insertCoupon = data;
        if (data) {
          let content = this.form.content ? this.form.content : "";
          this.form.content = content + " " + data + " ";
        }
      } else {
        if (data) {
          console.log(
            this.form.content &&
              this.form.content.indexOf(this.insertCoupon) != -1
          );
          if (
            this.form.content &&
            this.form.content.indexOf(this.insertCoupon) != -1
          ) {
            this.form.content = this.form.content.replace(
              this.insertCoupon,
              data
            );
          } else {
            let content = this.form.content ? this.form.content : "";
            this.form.content = content + " " + data + " ";
          }
        }
      }
      this.url = url;
      this.insertCoupon = data;
      this.insertShortUrlShow = false;
    },
    // 插入优惠券隐藏
    insertCouponChange(state, data) {
      this.insertCouponShow = false;
    },
    // 京东跳转App链接隐藏
    jdJumpLinkChange() {
      this.jdJumpLinkShow = false;
    },
    // 获取官方的短信签名
    getOfficialSuffix() {
      getPrecisionJdSuffixList(2).then((res) => {
        this.suffixList = res && res.data;
        console.log(res);
        this.form.smsSuffix = res && res.data[0];
      });
    },
    switchSuffix(item) {
      this.form.smsSuffix = item;
    },
    // 跳转至黑名单页面
    toBlack() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 短信测试发送号码变化监听
    sendMobileChange() {
      this.smsTest = this.smsTest && this.smsTest.replace("，", ",");
    },
    // 区分发送短信类型
    sendSmsTest(state = false) {
      const { content } = this.form;
      // if (!/^1[3456789]\d{9}$/.test(this.smsTest)) {
      //     this.$message.warning('请输入正确的手机号 !');
      //     return
      // }
      if (!content || !content.trim()) {
        this.$message.warning("请输入短信内容 !");
        return;
      } else {
        // 不能含有【 或 】 的字符
        if (content.indexOf('【') !== -1 || content.indexOf('】') !== -1) {
          this.$message.warning("短信内容不能含有【或】的符号哦！");
          return;
        }
      }
      if (state) {
        if (!this.smsTest || !this.smsTest.trim()) {
          this.$message.warning("请输入测试号码 !");
          return;
        }
      }
      state ? (this.isTestSend = true) : (this.isTestSend = false);
      this.sendSmsTestState = true;
    },
    // 发送短信测试弹窗隐藏
    sendSmsTestClose() {
      this.sendSmsTestState = false;
    },
    // 短信记录
    smsDialogClose(data) {
      this.smsDialogs = data;
    },
    transferName() {
      this.smsDialogs = false;
    },
    // smsDialogClose() {
    //   this.smsDialogs = false;
    // },

    handlePreSend() {
      let params;
      let type;
      if (this.isTestSend) {
        // 测试短信发送
        type = 1;
        params = {
          mobiles: this.smsTest,
          sendType: this.sendType,
          dataFrom: 0,
        };
      } else {
        // 短信发送
        type = 2;
        params = {
          sendType: this.sendType,
          dataFrom: this.dataFrom,
        };
        if (this.sendType == 1) {
          // 按查询结果发送0
          params = Object.assign(this.searchForm, params);
        } else if (this.sendType == 2) {
          // 勾选发送
          
          this.dataFrom == 1
            ? (params.pins = this.checkData.map((item) => item.pin || item))
            : (params.orderIds = this.checkData.map((item) => item.orderId));
        } else if(this.sendType == 0){
          console.log(this.checkData,22323);
          params.mobile = this.checkData;
        }
      }
      this.preLoading = true;
      preCommit(params).then((res) => {
        if (res.code == 1) {
          this.preLoading = false;
          this.sendObjectCount = res.data.sendObjectCount;
          this.sendObjectId = res.data.sendObjectId;
          // this.sendSms(res.data.sendObjectId, type);
        } else {
          // this.sendSmsTestState = false;
          this.$message.warning(res.message);
        }
      });
    },

    // 短信发送预提交
    handleSendConfirm() {
      // console.log(this.smsTest);

      let params;
      let type;
      if (this.isTestSend) {
        // 测试短信发送
        type = 1;
        params = {
          mobiles: this.smsTest,
          sendType: this.sendType,
          dataFrom: 0,
        };
      } else {
        this.sendSms(this.sendObjectId, type);
        return;
        // 短信发送
        // type = 2;
        // params = {
        //   sendType: this.sendType,
        //   dataFrom: this.dataFrom,
        // };
        // if (this.sendType == 1) {
        //   // 按查询结果发送0
        //   params = Object.assign(this.searchForm, params);
        // } else if (this.sendType == 2) {
        //   // 勾选发送
        //   this.dataFrom == 1
        //     ? (params.pins = this.checkData.map((item) => item.pin))
        //     : (params.orderIds = this.checkData.map((item) => item.orderId));
        // } else if(this.sendType == 0){
        //   console.log(this.checkData,22323);
        //   params.mobile = this.checkData;
        // }
      }
      this.preLoading = true;
      preCommit(params).then((res) => {
        if (res.code == 1) {
          this.preLoading = false;
          this.sendSms(res.data.sendObjectId, type);
        } else {
          // this.sendSmsTestState = false;
          this.$message.warning(res.message);
        }
      });
    },

    // 短信发送
    sendSms(id, type) {
      let params = {};
      console.log(type);
      if (type == "1") {
        // 测试短信的发送
        params = {
          content: this.form.content + this.TTip,
          sendObjectId: id,
          smsSuffix: this.form.smsSuffix,
          blackFlag: false,
        };
      } else {
        params = this.deepCopy(this.form);
        params.sendObjectId = id;
        params.content = params.content + this.TTip;
        params.sendTime = this.sendStart + " " + this.sendEnd;
        if (this.form.content.indexOf(this.insertCoupon) != -1) {
          params.jdShortLink = this.insertCoupon;
          console.log(this.url);
          params.url = this.url;
        }
      }
       this.sendSmsTestState = false;
      platformSend(params).then((res) => {
        if (res.code == 1) {
          if (type == 1) {
            this.$message.success("发送成功");
          } else {
            this.successDialog = true;
          }
          // if (!this.isTestSend) this.handleClose();
        } else {
          this.$message.warning(res.message);
        }
        // this.sendSmsTestState = false;
      });
    },
    // 获取当前时间
    getNowDate() {
      var myDate = new Date(); //实例一个时间对象；
      const y = myDate.getFullYear(); //获取系统的年；
      const M = myDate.getMonth() + 1; //获取系统月份，由于月份是从0开始计算，所以要加1
      const d = myDate.getDate(); // 获取系统日，
      const h = myDate.getHours(); //获取系统时，
      const m = myDate.getMinutes(); //分
      const s = myDate.getSeconds(); //秒
      return y + String(M) + d + " " + h + ":" + m + ":" + s;
    },
    deepCopy(obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
  },
};
</script>
<style scoped lang="scss">
// ::v-deep .pickerTime .el-input--small .el-input__icon {
//     line-height: 32px;
//     padding: 0 0 0 110px !important;
// }
::v-deep .pickerTime .el-icon-date:before {
    content: "\E78E";
    padding: 0 0 0 107px !important;
}
 ::v-deep .pickerTime .el-icon-time:before {
    content: "\E71F";
    padding: 0 0 0 107px !important;
}
 ::v-deep .textareaChange .el-textarea__inner {
    border: 1px solid #dcdfe6  !important;
    &:focus{
      border: 1px solid #fe4d45 !important;
    }  
}
//  ::v-deep .el-icon-close:before {
//     content: "\E6DB";
//     &:hover{
//       color: #fe4d45 !important;
//     }
// }

</style>
<style scoped lang="scss">
.activeTip {
  color: #FE4D45;
  // padding-left: 30px;
  line-height: 25px;
  padding-bottom: 10px;
}
/* 发送确认弹窗 */
.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;
    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .btn-group {
    margin-top: 30px;
    text-align: center;
  }
}
.el-icon-close{
   &:hover{
      color: #fe4d45 !important;
    }
}
.sendSms {
  button {
    cursor: pointer;
  }
  /deep/ .el-drawer__wrapper {
    z-index: 2900 !important;
  }
  /deep/ .el-drawer__body {
    height: 100%;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .head {
    flex: 0 0 62px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 28px;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
    p {
      margin: 0;
    }
    .left {
      display: flex;
      align-items: center;
    }
    .close {
      color: #ccc;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
    }
    .tit {
      color: #333;
      font-size: 16px;
      margin-right: 12px;
      font-weight: 500;
    }
  }
  .topTis {
    display: flex;
    margin: 30px 48px;
    align-items: baseline;
    color: #333333;
    box-sizing: border-box;
    background-color: #fafafa;
    font-size: 14px;
    padding: 15px;
    line-height: 25px;
    border-radius: 3px;
    span {
      color: #fe4d45;
      cursor: pointer;
    }
  }
  .main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 70%;
    box-sizing: border-box;
    padding: 0 60px 0 48px;
    p {
      margin: 0;
    }

    .textarea {
      box-sizing: border-box;
      padding: 6px 6px 10px;
      width: 100%;
      background: rgba(249, 250, 251, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 2px;
      .footInfo {
        display: flex;
        justify-content: space-between;
        margin-top: 9px;
        font-size: 14px;
        color: #333;
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 76px;
          height: 28px;
          outline: none;
          border: none;
          background-color: white;
          border-radius: 2px;
          font-size: 14px;
        }
        div {
          display: flex;
          align-items: center;
        }
        .select {
          // margin: 0 10px 0 8px;
          width: 76px;
          height: 28px;
          opacity: 1;
          border-radius: 3px;
          font-size: 13px;
          margin-right: 8px;
          cursor: pointer;
          border: 1px solid #fe4d45;
          color: #fe4d45;
          background-color: #fff4f4;
          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }
        }
            .question_icon {
      width: 14px;
      height: 14px;
      color: #7f85e9 !important;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #7f85e9;
      font-size: 12px !important;
      font-weight: normal !important;
      margin-left: 8px;
      &:hover {
        color: #fe4d45 !important;
        border: 1px solid #fe4d45;
      }
    }
        .keep {
          // margin: 0 10px 0 8px;
          width: 76px;
          height: 28px;
          border-radius: 3px;
          font-size: 13px;
          /* font-family: PingFang SC; */
          font-weight: 400;
          margin-right: 8px;
          cursor: pointer;
          color: #ffffff;
          background-color: #fe4d45;
          &:hover {
            color: #fff;
            opacity: 0.9;
            background-color: #fe4d45;
          }
        }
      }
      // .ask-content {
      //   position: relative;
      //   display: inline-block;
      //   vertical-align: middle;
      //   cursor: pointer;
      //   .ask-icon {
      //     display: inline-block;
      //     vertical-align: middle;
      //     cursor: pointer;
      //     position: relative;
      //   }

      // .ask-icon-select {
      //   position: absolute;
      //   bottom: -143px;
      //   margin-left: -158px;
      //   display: none;
      //   width: 375px;
      //   // height: 80px;

      //   line-height: 20px;
      //   padding: 20px;
      //   background-color: #fff;
      //   text-align: left;
      //   box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
      //   color: #999999;
      // }
      // .ask-icon-select:before {
      //   position: absolute;
      //   content: "";
      //   width: 0;
      //   height: 0;
      //   right: 50%;
      //   margin-left: -4px;
      //   bottom: 100%;
      //   border-left: 8px solid transparent;
      //   border-top: 8px solid #fff;
      //   border-right: 8px solid transparent;
      // }
      // }
      // .ask-content:hover {
      //   .ask-icon-select {
      //     display: block;
      //   }
      // }
    }
    .footTips {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-top: 8px;
      padding-left: 12px;
      height: 28px;
      background: rgba(255, 250, 238, 1);
      border: 1px solid rgba(255, 185, 94, 1);
      border-radius: 2px;
      color: #333;
      font-size: 14px;
    }
    .tool {
     display: flex;
      align-items: center;
      height: 32px;
      p {
        box-sizing: border-box;
        padding: 0 8px;
        margin: 0 8px 0 0;
        font-size: 14px;
      border-radius: 3px;
      background-color: #f7f8fe;
      border: 1px solid #7f85e9;
      color: #7f85e9;
      &:hover {
        background: rgba(174, 179, 241, 0.16);
        border: 1px solid #7f85e9 !important;
        color: #7f85e9 !important;
      }
      &:active {
        background: rgba(174, 179, 241, 0.24);
        border: 1px solid #7f85e9 !important;
        color: #7f85e9;
      }
      }
    }
    .btnList {
      display: flex;
      align-items: center;
      height: 32px;
      button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 2px;
        cursor: pointer;
      }
      .btnListButtom{
        color: rgb(127, 133, 233);
        &:hover{
          color: #fe4d45;
        }
      }
      .btnBox {
        position: relative;
        overflow: hidden;
        height: 31px;
        margin-right: 16px;
        .btn {
          padding: 5px 12px;
          height: 31px;
          border: 1px solid rgba(254, 77, 69, 1);
          color: #fe4d45;
          cursor: pointer;
        }
        .check {
          position: absolute;
          right: -16px;
          bottom: -15px;
          width: 30px;
          height: 30px;
          background-color: #fe4d45;
          border-radius: 50%;
        }
        i {
          position: absolute;
          right: 16px;
          bottom: 15px;
          font-size: 10px;
          color: #fff;
        }
      }
    }
    .test {
      font-size: 14px;
      button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 2px;
        width: 98px;
        height: 32px;
        line-height: 31px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .ipt {
        width: 240px;
        margin: 0 8px 0 0px;
      }
      .sendTest {
        color: #fe4d45;
        border: 1px solid rgba(254, 77, 69, 1);
        &:hover {
          background-color: #fe4d45;
          color: #fff;
        }
      }
      .record {
        margin: 0 24px 0 8px;
        color: #999999;
        border-radius: 3px;
        border: 1px solid #cccccc;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
    .info {
      margin-top: 12px;
      line-height: 22px;
      font-size: 14px;
      color: #999;
    }
  }
  .foot {
    flex: 0 0 80px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 48px;
    border-top: 1px solid #f0f0f0;
    flex-shrink: 0;
    .btn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-right: 24px;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      cursor: pointer;
      border: none;
      outline: none;
      color: #fff;
    }
    .txt {
      color: #333;
      font-size: 14px;
      .num {
        color: #fe4d45;
      }
    }
  }
  .selectBox {
    text-align: right;
    .headCnt {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }
    .keepBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }
    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }
  }
  .insertBox {
    text-align: right;
    .inser {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }
    .createUrlBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }
    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }
    .tip_box {
      text-align: left;
      line-height: 20px;
      margin-top: 10px;
      color: #fe4d45;
    }
  }
  .jumpLinkBox {
    .item {
      display: flex;
      align-items: center;
      margin-top: 20px;
      label {
        width: 80px;
        flex-shrink: 0;
        text-align: right;
        color: #333;
        font-size: 14px;
      }
    }
    .create {
      margin-top: 20px;
      text-align: right;
      .createBtn {
        border: none;
        width: 98px;
        height: 32px;
        line-height: 30px;
        background: rgba(254, 77, 69, 1);
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 3px;
        text-align: center;
        color: #fff;
      }
    }
  }
  .mobile-box {
    position: relative;
    width: 256px;
    height: 504px;
    .message-content {
      position: absolute;
      word-wrap: break-word;
      background-color: #fafafa;
      max-height: 250px;
      overflow-y: auto;
      padding: 12px 12px;
      border-radius: 6px;
      padding-right: 5px;
      width: 210px;
      font-size: 14px;
      line-height: 20px;
      left: 50%;
      margin-left: -104.665px;
      text-align: left;
      top: 25.4%;
    }
  }
  .mobile-tips {
    margin-top:16px;
    font-size:16px;
    text-align: center;
  }
  .sendSmsTestWrap {
    text-align: center;
    p {
      margin: 40px 0;
    }
  }
  .xiao_hug2 {
    position: absolute;
    top: 20px;
    left: 980px;
  }
  @media screen and (max-width: 1580px) {
    .xiao_hug2 {
      left: 950px;
    }
  }
}
</style>
<style lang="scss">
.sendSms {
  .el-drawer {
    min-width: 1300px;
  }
  .el-form-item__label {
    text-align: left;
  }
  .el-radio-group {
    display: flex;
    align-items: center;
  }
}
</style>
